import {Container} from '@inlet/react-pixi';
import React, {RefObject} from 'react';
import {ReactButton, TextVariables} from '@gongxigames/framework/core/fragments/react/components/ReactButton';
import {Container as PixiContainer} from 'pixi.js';
import {AUTOMATION_META, AutomationMeta} from '@gongxigames/framework/core/fragments/Autotest';

type BackgroundStyle = {
    borderColor?: number;
    borderThickness?: number;
    backgroundColor?: number;
};

export type ToggleButtonWithTitleProps = {
    onToggle: (value: boolean) => void;
    disabled?: boolean;
    visible?: boolean;
    name?: string;
    x?: number;
    y?: number;
    onBackground: BackgroundStyle;
    offBackground: BackgroundStyle;
    round?: number;
    title: string | {id: string;};
    textStyleId?: string;
    width?: number;
    height?: number;
    value: boolean;
};

export class ToggleButtonWithTitle extends React.Component<ToggleButtonWithTitleProps> {
    btnRef: RefObject<PixiContainer>;

    constructor(props: ToggleButtonWithTitleProps) {
        super(props);

        this.btnRef = React.createRef();
    }

    protected onToggle(): void {
        this.props.onToggle(!this.props.value);
    }

    protected getTextProps(): {textId: string; textVariables?: TextVariables;} {
        if (typeof this.props.title === 'string') {
            return {
                textId: 'toggleButtonWithTitleTemplate',
                textVariables: {title: this.props.title}
            };
        }

        return {
            textId: this.props.title.id
        };
    }

    public render(): JSX.Element {
        const {
            onBackground,
            offBackground,
            round,
            disabled,
            value,
            width,
            height,
            textStyleId,
            name = 'ToggleButtonWithTitle',
            ...containerProps
        } = this.props;
        const {textId, textVariables} = this.getTextProps();
        const style = value ? onBackground : offBackground;

        if (this.btnRef.current) {
            (this.btnRef.current as any)[AUTOMATION_META] = () => {
                const automationMeta: AutomationMeta = {
                    type: 'button_simple'
                };

                return automationMeta;
            };
        }

        return (
            <Container name={name} {...containerProps}>
                <ReactButton
                    textId={textId}
                    textVariables={textVariables}
                    width={width}
                    height={height}
                    textStyleId={textStyleId}
                    round={round}
                    disabled={disabled}
                    borderColor={style.borderColor}
                    backgroundColor={style.backgroundColor}
                    borderThickness={style.borderThickness}
                    onClick={this.onToggle.bind(this)}
                />
            </Container>
        );
    }
}
